module["exports"] = [
  "Schweiz"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/address/default_country.js
// module id = 1018
// module chunks = 1